// Code generated by Wire protocol buffer compiler, do not edit.
// Source: vreo.volt.protocol.AnprMessage in anprMessage/anprMessage.proto
@file:Suppress(
  "DEPRECATION",
  "RUNTIME_ANNOTATION_NOT_SUPPORTED",
)

package vreo.volt.protocol

import com.squareup.wire.FieldEncoding
import com.squareup.wire.Message
import com.squareup.wire.ProtoAdapter
import com.squareup.wire.ProtoReader
import com.squareup.wire.ProtoWriter
import com.squareup.wire.ReverseProtoWriter
import com.squareup.wire.Syntax.PROTO_3
import com.squareup.wire.WireField
import com.squareup.wire.`internal`.JvmField
import com.squareup.wire.`internal`.immutableCopyOf
import com.squareup.wire.`internal`.redactElements
import com.squareup.wire.`internal`.sanitize
import kotlin.Any
import kotlin.AssertionError
import kotlin.Boolean
import kotlin.Deprecated
import kotlin.DeprecationLevel
import kotlin.Float
import kotlin.Int
import kotlin.Long
import kotlin.Nothing
import kotlin.String
import kotlin.Suppress
import kotlin.collections.List
import okio.ByteString

/**
 * Anpr message. Represents anpr message.
 *
 * @property uuid UUID of the message
 * @property device Device type e.g. volt
 * @property model Device model e.g. s1
 * @property serial_number Device serial number
 * @property software_version Device software version
 * @property ocr_version OCR version
 * @property vehicle_id Vehicle id
 * @property license_plate License plate number
 * @property license_plate_width License plate width in pixels
 * @property license_plate_height License plate height in pixels
 * @property confidence_score OCR confidence score
 * @property ocr_attempt OCR attempt number
 * @property image_url Image associated with this message URL
 * @property time_stamp Unix time stamp of the message in seconds
 * @property telemetry_message Message type, false = norma. and true = telemetry
 * @property telemetry Telemetry readings
 */
public class AnprMessage(
  @field:WireField(
    tag = 1,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 0,
  )
  public val uuid: String = "",
  @field:WireField(
    tag = 2,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 1,
  )
  public val device: String = "",
  @field:WireField(
    tag = 3,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    schemaIndex = 2,
  )
  public val model: String = "",
  @field:WireField(
    tag = 4,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "serialNumber",
    schemaIndex = 3,
  )
  public val serial_number: String = "",
  @field:WireField(
    tag = 5,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "softwareVersion",
    schemaIndex = 4,
  )
  public val software_version: String = "",
  @field:WireField(
    tag = 6,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "ocrVersion",
    schemaIndex = 5,
  )
  public val ocr_version: String = "",
  @field:WireField(
    tag = 7,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "vehicleId",
    schemaIndex = 6,
  )
  public val vehicle_id: Int = 0,
  @field:WireField(
    tag = 8,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "licensePlate",
    schemaIndex = 7,
  )
  public val license_plate: String = "",
  @field:WireField(
    tag = 9,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "licensePlateWidth",
    schemaIndex = 8,
  )
  public val license_plate_width: Int = 0,
  @field:WireField(
    tag = 10,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "licensePlateHeight",
    schemaIndex = 9,
  )
  public val license_plate_height: Int = 0,
  @field:WireField(
    tag = 11,
    adapter = "com.squareup.wire.ProtoAdapter#FLOAT",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "confidenceScore",
    schemaIndex = 10,
  )
  public val confidence_score: Float = 0f,
  @field:WireField(
    tag = 12,
    adapter = "com.squareup.wire.ProtoAdapter#INT32",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "ocrAttempt",
    schemaIndex = 11,
  )
  public val ocr_attempt: Int = 0,
  @field:WireField(
    tag = 13,
    adapter = "com.squareup.wire.ProtoAdapter#STRING",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "imageUrl",
    schemaIndex = 12,
  )
  public val image_url: String = "",
  @field:WireField(
    tag = 14,
    adapter = "com.squareup.wire.ProtoAdapter#INT64",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "timeStamp",
    schemaIndex = 13,
  )
  public val time_stamp: Long = 0L,
  @field:WireField(
    tag = 15,
    adapter = "com.squareup.wire.ProtoAdapter#BOOL",
    label = WireField.Label.OMIT_IDENTITY,
    jsonName = "telemetryMessage",
    schemaIndex = 14,
  )
  public val telemetry_message: Boolean = false,
  telemetry: List<TelemetryType> = emptyList(),
  unknownFields: ByteString = ByteString.EMPTY,
) : Message<AnprMessage, Nothing>(ADAPTER, unknownFields) {
  @field:WireField(
    tag = 16,
    adapter = "vreo.volt.protocol.TelemetryType#ADAPTER",
    label = WireField.Label.REPEATED,
    schemaIndex = 15,
  )
  public val telemetry: List<TelemetryType> = immutableCopyOf("telemetry", telemetry)

  @Deprecated(
    message = "Shouldn't be used in Kotlin",
    level = DeprecationLevel.HIDDEN,
  )
  override fun newBuilder(): Nothing = throw AssertionError("Builders are deprecated and only available in a javaInterop build; see https://square.github.io/wire/wire_compiler/#kotlin")

  override fun equals(other: Any?): Boolean {
    if (other === this) return true
    if (other !is AnprMessage) return false
    if (unknownFields != other.unknownFields) return false
    if (uuid != other.uuid) return false
    if (device != other.device) return false
    if (model != other.model) return false
    if (serial_number != other.serial_number) return false
    if (software_version != other.software_version) return false
    if (ocr_version != other.ocr_version) return false
    if (vehicle_id != other.vehicle_id) return false
    if (license_plate != other.license_plate) return false
    if (license_plate_width != other.license_plate_width) return false
    if (license_plate_height != other.license_plate_height) return false
    if (confidence_score != other.confidence_score) return false
    if (ocr_attempt != other.ocr_attempt) return false
    if (image_url != other.image_url) return false
    if (time_stamp != other.time_stamp) return false
    if (telemetry_message != other.telemetry_message) return false
    if (telemetry != other.telemetry) return false
    return true
  }

  override fun hashCode(): Int {
    var result = super.hashCode
    if (result == 0) {
      result = unknownFields.hashCode()
      result = result * 37 + uuid.hashCode()
      result = result * 37 + device.hashCode()
      result = result * 37 + model.hashCode()
      result = result * 37 + serial_number.hashCode()
      result = result * 37 + software_version.hashCode()
      result = result * 37 + ocr_version.hashCode()
      result = result * 37 + vehicle_id.hashCode()
      result = result * 37 + license_plate.hashCode()
      result = result * 37 + license_plate_width.hashCode()
      result = result * 37 + license_plate_height.hashCode()
      result = result * 37 + confidence_score.hashCode()
      result = result * 37 + ocr_attempt.hashCode()
      result = result * 37 + image_url.hashCode()
      result = result * 37 + time_stamp.hashCode()
      result = result * 37 + telemetry_message.hashCode()
      result = result * 37 + telemetry.hashCode()
      super.hashCode = result
    }
    return result
  }

  override fun toString(): String {
    val result = mutableListOf<String>()
    result += """uuid=${sanitize(uuid)}"""
    result += """device=${sanitize(device)}"""
    result += """model=${sanitize(model)}"""
    result += """serial_number=${sanitize(serial_number)}"""
    result += """software_version=${sanitize(software_version)}"""
    result += """ocr_version=${sanitize(ocr_version)}"""
    result += """vehicle_id=$vehicle_id"""
    result += """license_plate=${sanitize(license_plate)}"""
    result += """license_plate_width=$license_plate_width"""
    result += """license_plate_height=$license_plate_height"""
    result += """confidence_score=$confidence_score"""
    result += """ocr_attempt=$ocr_attempt"""
    result += """image_url=${sanitize(image_url)}"""
    result += """time_stamp=$time_stamp"""
    result += """telemetry_message=$telemetry_message"""
    if (telemetry.isNotEmpty()) result += """telemetry=$telemetry"""
    return result.joinToString(prefix = "AnprMessage{", separator = ", ", postfix = "}")
  }

  public fun copy(
    uuid: String = this.uuid,
    device: String = this.device,
    model: String = this.model,
    serial_number: String = this.serial_number,
    software_version: String = this.software_version,
    ocr_version: String = this.ocr_version,
    vehicle_id: Int = this.vehicle_id,
    license_plate: String = this.license_plate,
    license_plate_width: Int = this.license_plate_width,
    license_plate_height: Int = this.license_plate_height,
    confidence_score: Float = this.confidence_score,
    ocr_attempt: Int = this.ocr_attempt,
    image_url: String = this.image_url,
    time_stamp: Long = this.time_stamp,
    telemetry_message: Boolean = this.telemetry_message,
    telemetry: List<TelemetryType> = this.telemetry,
    unknownFields: ByteString = this.unknownFields,
  ): AnprMessage = AnprMessage(uuid, device, model, serial_number, software_version, ocr_version, vehicle_id, license_plate, license_plate_width, license_plate_height, confidence_score, ocr_attempt, image_url, time_stamp, telemetry_message, telemetry, unknownFields)

  public companion object {
    @JvmField
    public val ADAPTER: ProtoAdapter<AnprMessage> = object : ProtoAdapter<AnprMessage>(
      FieldEncoding.LENGTH_DELIMITED, 
      AnprMessage::class, 
      "type.googleapis.com/vreo.volt.protocol.AnprMessage", 
      PROTO_3, 
      null, 
      "anprMessage/anprMessage.proto"
    ) {
      override fun encodedSize(`value`: AnprMessage): Int {
        var size = value.unknownFields.size
        if (value.uuid != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(1, value.uuid)
        }
        if (value.device != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(2, value.device)
        }
        if (value.model != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(3, value.model)
        }
        if (value.serial_number != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(4, value.serial_number)
        }
        if (value.software_version != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(5, value.software_version)
        }
        if (value.ocr_version != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(6, value.ocr_version)
        }
        if (value.vehicle_id != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(7, value.vehicle_id)
        }
        if (value.license_plate != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(8, value.license_plate)
        }
        if (value.license_plate_width != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(9, value.license_plate_width)
        }
        if (value.license_plate_height != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(10, value.license_plate_height)
        }
        if (!value.confidence_score.equals(0f)) {
          size += ProtoAdapter.FLOAT.encodedSizeWithTag(11, value.confidence_score)
        }
        if (value.ocr_attempt != 0) {
          size += ProtoAdapter.INT32.encodedSizeWithTag(12, value.ocr_attempt)
        }
        if (value.image_url != "") {
          size += ProtoAdapter.STRING.encodedSizeWithTag(13, value.image_url)
        }
        if (value.time_stamp != 0L) {
          size += ProtoAdapter.INT64.encodedSizeWithTag(14, value.time_stamp)
        }
        if (value.telemetry_message != false) {
          size += ProtoAdapter.BOOL.encodedSizeWithTag(15, value.telemetry_message)
        }
        size += TelemetryType.ADAPTER.asRepeated().encodedSizeWithTag(16, value.telemetry)
        return size
      }

      override fun encode(writer: ProtoWriter, `value`: AnprMessage) {
        if (value.uuid != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.uuid)
        }
        if (value.device != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 2, value.device)
        }
        if (value.model != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 3, value.model)
        }
        if (value.serial_number != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 4, value.serial_number)
        }
        if (value.software_version != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 5, value.software_version)
        }
        if (value.ocr_version != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 6, value.ocr_version)
        }
        if (value.vehicle_id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 7, value.vehicle_id)
        }
        if (value.license_plate != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 8, value.license_plate)
        }
        if (value.license_plate_width != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 9, value.license_plate_width)
        }
        if (value.license_plate_height != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 10, value.license_plate_height)
        }
        if (!value.confidence_score.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 11, value.confidence_score)
        }
        if (value.ocr_attempt != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 12, value.ocr_attempt)
        }
        if (value.image_url != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 13, value.image_url)
        }
        if (value.time_stamp != 0L) {
          ProtoAdapter.INT64.encodeWithTag(writer, 14, value.time_stamp)
        }
        if (value.telemetry_message != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 15, value.telemetry_message)
        }
        TelemetryType.ADAPTER.asRepeated().encodeWithTag(writer, 16, value.telemetry)
        writer.writeBytes(value.unknownFields)
      }

      override fun encode(writer: ReverseProtoWriter, `value`: AnprMessage) {
        writer.writeBytes(value.unknownFields)
        TelemetryType.ADAPTER.asRepeated().encodeWithTag(writer, 16, value.telemetry)
        if (value.telemetry_message != false) {
          ProtoAdapter.BOOL.encodeWithTag(writer, 15, value.telemetry_message)
        }
        if (value.time_stamp != 0L) {
          ProtoAdapter.INT64.encodeWithTag(writer, 14, value.time_stamp)
        }
        if (value.image_url != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 13, value.image_url)
        }
        if (value.ocr_attempt != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 12, value.ocr_attempt)
        }
        if (!value.confidence_score.equals(0f)) {
          ProtoAdapter.FLOAT.encodeWithTag(writer, 11, value.confidence_score)
        }
        if (value.license_plate_height != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 10, value.license_plate_height)
        }
        if (value.license_plate_width != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 9, value.license_plate_width)
        }
        if (value.license_plate != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 8, value.license_plate)
        }
        if (value.vehicle_id != 0) {
          ProtoAdapter.INT32.encodeWithTag(writer, 7, value.vehicle_id)
        }
        if (value.ocr_version != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 6, value.ocr_version)
        }
        if (value.software_version != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 5, value.software_version)
        }
        if (value.serial_number != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 4, value.serial_number)
        }
        if (value.model != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 3, value.model)
        }
        if (value.device != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 2, value.device)
        }
        if (value.uuid != "") {
          ProtoAdapter.STRING.encodeWithTag(writer, 1, value.uuid)
        }
      }

      override fun decode(reader: ProtoReader): AnprMessage {
        var uuid: String = ""
        var device: String = ""
        var model: String = ""
        var serial_number: String = ""
        var software_version: String = ""
        var ocr_version: String = ""
        var vehicle_id: Int = 0
        var license_plate: String = ""
        var license_plate_width: Int = 0
        var license_plate_height: Int = 0
        var confidence_score: Float = 0f
        var ocr_attempt: Int = 0
        var image_url: String = ""
        var time_stamp: Long = 0L
        var telemetry_message: Boolean = false
        val telemetry = mutableListOf<TelemetryType>()
        val unknownFields = reader.forEachTag { tag ->
          when (tag) {
            1 -> uuid = ProtoAdapter.STRING.decode(reader)
            2 -> device = ProtoAdapter.STRING.decode(reader)
            3 -> model = ProtoAdapter.STRING.decode(reader)
            4 -> serial_number = ProtoAdapter.STRING.decode(reader)
            5 -> software_version = ProtoAdapter.STRING.decode(reader)
            6 -> ocr_version = ProtoAdapter.STRING.decode(reader)
            7 -> vehicle_id = ProtoAdapter.INT32.decode(reader)
            8 -> license_plate = ProtoAdapter.STRING.decode(reader)
            9 -> license_plate_width = ProtoAdapter.INT32.decode(reader)
            10 -> license_plate_height = ProtoAdapter.INT32.decode(reader)
            11 -> confidence_score = ProtoAdapter.FLOAT.decode(reader)
            12 -> ocr_attempt = ProtoAdapter.INT32.decode(reader)
            13 -> image_url = ProtoAdapter.STRING.decode(reader)
            14 -> time_stamp = ProtoAdapter.INT64.decode(reader)
            15 -> telemetry_message = ProtoAdapter.BOOL.decode(reader)
            16 -> telemetry.add(TelemetryType.ADAPTER.decode(reader))
            else -> reader.readUnknownField(tag)
          }
        }
        return AnprMessage(
          uuid = uuid,
          device = device,
          model = model,
          serial_number = serial_number,
          software_version = software_version,
          ocr_version = ocr_version,
          vehicle_id = vehicle_id,
          license_plate = license_plate,
          license_plate_width = license_plate_width,
          license_plate_height = license_plate_height,
          confidence_score = confidence_score,
          ocr_attempt = ocr_attempt,
          image_url = image_url,
          time_stamp = time_stamp,
          telemetry_message = telemetry_message,
          telemetry = telemetry,
          unknownFields = unknownFields
        )
      }

      override fun redact(`value`: AnprMessage): AnprMessage = value.copy(
        telemetry = value.telemetry.redactElements(TelemetryType.ADAPTER),
        unknownFields = ByteString.EMPTY
      )
    }

    private const val serialVersionUID: Long = 0L
  }
}
